export default {"src":"/_next/static/media/GraphLow2.23c82563.gif","height":388,"width":690};